var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1467 480L1467 508",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1467.5,
    cy: 475.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1462.99 475.19C1462.99 471.283 1466.29 468.117 1470.36 468.117C1470.94 468.117 1471.51 468.184 1472.06 468.308C1470.74 467.48 1469.19 467 1467.52 467C1462.81 467 1459 470.806 1459 475.5C1459 480.194 1462.81 484 1467.52 484C1469.81 484 1471.89 483.093 1473.43 481.62C1472.49 482.032 1471.45 482.263 1470.36 482.263C1466.29 482.263 1462.99 479.096 1462.99 475.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1476.4 474.6L1476.37 472.146L1474.54 473.719L1472.3 473.056L1473.11 475.337L1471.77 477.381L1474.1 477.218L1475.5 479.144L1476.13 476.763L1478.34 475.909L1476.4 474.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.3c7a4a3309f565212583bf6be4a61b6f.svg";
export { ForwardRef as ReactComponent };